import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgDualIcon = createSvgIcon(
  [
    <path key='1' d='M62,5c0.7-1.3,0.3-2.9-1-3.6s-2.8-0.2-3.6,1L44.8,24.3c-0.7,1.3-0.3,2.9,1,3.6s2.9,0.2,3.6-1.1L62,5z' />,
    <path
      key='2'
      d='M38.3,59.3H25.6c-2.4,0-4.2-1.9-4.2-4.2V20.2c0-2.4,1.9-4.2,4.2-4.2h12.9c2.4,0,4.2,1.9,4.2,4.2v34.9
	C42.6,57.4,40.8,59.3,38.3,59.3z'
    />,
    <path key='3' d='M14.6,26.8c0.7,1.3,2.3,1.8,3.6,1.1s1.7-2.3,1-3.6L6.5,2.4c-0.8-1.2-2.3-1.7-3.6-1S1.2,3.7,1.9,5L14.6,26.8z' />,
  ],
  'TransportCoverDualOpenIcon'
);

const SvgLeftIcon = createSvgIcon(
  [
    <path key='1' d='M50.8,21.1c0-1.5-1.2-2.6-2.7-2.6s-2.6,1.2-2.6,2.7l0.1,31.3c0,1.5,1.2,2.6,2.7,2.6s2.6-1.2,2.6-2.7L50.8,21.1z' />,
    <path
      key='2'
      d='M38.3,59.3H25.5c-2.4,0-4.2-1.9-4.2-4.2V20.2c0-2.4,1.9-4.2,4.2-4.2h12.9c2.4,0,4.2,1.9,4.2,4.2v34.9
	C42.7,57.4,40.8,59.3,38.3,59.3z'
    />,
    <path key='3' d='M14.7,26.8c0.7,1.3,2.3,1.8,3.6,1.1s1.7-2.3,1-3.6L6.5,2.4C5.7,1.2,4.2,0.7,3,1.4S1.2,3.7,2,5L14.7,26.8z' />,
  ],
  'TransportCoverLeftOpenIcon'
);

const SvgRightIcon = createSvgIcon(
  [
    <path
      key='1'
      d='M38.3,59.3H25.5c-2.4,0-4.2-1.9-4.2-4.2V20.2c0-2.4,1.9-4.2,4.2-4.2h12.9c2.4,0,4.2,1.9,4.2,4.2v34.9
	C42.7,57.4,40.8,59.3,38.3,59.3z'
    />,
    <path key='2' d='M18.4,21.1c0-1.5-1.2-2.6-2.7-2.6s-2.6,1.2-2.6,2.7l0.1,31.3c0,1.5,1.2,2.6,2.7,2.6s2.6-1.2,2.6-2.7L18.4,21.1z' />,
    <path key='3' d='M62,5c0.7-1.3,0.3-2.9-1-3.6s-2.8-0.2-3.6,1L44.8,24.3c-0.7,1.3-0.3,2.9,1,3.6s2.9,0.2,3.6-1.1L62,5z' />,
  ],
  'TransportCoverRightOpenIcon'
);

const TransportCoverDualOpenIcon = function (props) {
  const { position = 'dual', ...rest } = props;

  switch (position) {
    case 'left':
      return <SvgLeftIcon {...rest} />;
    case 'right':
      return <SvgRightIcon {...rest} />;
    case 'dual':
      return <SvgDualIcon {...rest} />;
  }
};

export default memo(TransportCoverDualOpenIcon);
